<template>
  <section class="par">
    <div class="par__glow par__glow--orange" aria-hidden="true"></div>
    <div class="par__glow par__glow--blue" aria-hidden="true"></div>
    <div class="par__dots" aria-hidden="true"></div>

    <div class="par__container">
      <div class="par__head reveal">
        <p class="par__eyebrow">Assuraf</p>
        <h2 class="par__title">
          <template v-if="isPro">
            Ils nous font confiance
          </template>
          <template v-else>
            {{ $t('home_page.partenaires_title[0]') }}
            <span class="par__title-accent">{{ $t('home_page.partenaires_title[1]') }}</span>
          </template>
        </h2>
        <span class="par__bar"></span>
      </div>

      <div class="par__marquee reveal">
        <div class="par__track">
          <div class="par__group" v-for="group in trackGroups" :key="group">
            <div class="par__slide" v-for="(assure, index) in displayList" :key="index">
              <img :src="assure.src" :alt="assure.alt" loading="lazy" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Api from '../../../services/Api';
import { logosAssureurs } from '../../../common/ilsNousfontConfiancePro';

export default {
  name: 'partenaire_section',
  props: {
    type: {
      type: String,
      default: 'base',
      validator: v => ['pro', 'base'].includes(v)
    }
  },
  data: () => ({
    listeAssureurs: [],
    listeAssureurs2: logosAssureurs,
    listeLogoFromApi: [
      { societe: 'AXA' },
      { societe: 'NSIA' },
      { societe: 'ASKIA' },
      { societe: 'SUNU' },
      { societe: 'CNART' },
      { societe: 'ALLIANZ' },
      { societe: 'SONAM GENERALE ASSURANCES' },
      { societe: 'FINAFRICA' },
      { societe: 'PROVIDENCE' },
      { societe: 'SAAR' },
      { societe: 'SANLAM' },
      { societe: 'SONAC' },
      { societe: 'ASS' },
      { societe: 'AMSA' },
      { societe: 'CNAAS' },
      { societe: 'PA' }
    ],
    title: 'Assuraf',
    description:
      'Le meilleur de l\'assurance en ligne au Sénégal. Faites votre devis, souscrivez et payez en ligne: vous êtes assuré ! Un service simple, une offre claire et complète, une expérience proactive et multicanale.'
  }),

  metaInfo() {
    return {
      title: this.title,
      meta: [
        {
          charset: 'utf-8'
        },
        {
          name: 'description',
          content: this.description
        }
      ]
    };
  },

  computed: {
    isPro() {
      return this.type === 'pro' || this.$route.name === 'assuraf_pro_online';
    },
    displayList() {
      if (this.isPro) {
        return this.listeAssureurs2.map(assure => ({
          src: require('@/assets/img/' + assure.logoUrl),
          alt: assure.logoTitle
        }));
      }
      const list = [];
      list.push({
        src: require('../../../assets/img/assureur/Logo_Sanlam_Allianz.png'),
        alt: 'Sanlam Allianz'
      });
      this.listeAssureurs.forEach(assure => {
        list.push({ src: assure.logo, alt: assure.societe });
      });
      list.push({
        src: require('../../../assets/img/assureur/wafa.png'),
        alt: 'Wafa'
      });
      return list;
    },
    trackGroups() {
      return [0, 1, 2];
    }
  },

  methods: {
    async getListePartenaire() {
      Api()
        .get('partenaire/assureur')
        .then(response => {
          this.listeAssureurs = response.data.partenaires;
          const myFilter = this.listeLogoFromApi;
          this.listeAssureurs = this.listeAssureurs.filter(el =>
            myFilter.some(f => f.societe === el.societe)
          );
        });
    }
  },

  mounted() {
    if (!this.isPro) {
      this.getListePartenaire();
    }
  }
};
</script>

<style lang="less" scoped>

@import "../../../assets/less/config";

.par {
  position: relative;
  overflow: hidden;
  padding: 96px 24px;
  background: linear-gradient(180deg, #fff 0%, #FFFBF6 100%);

  &__glow {
    position: absolute;
    border-radius: 50%;
    filter: blur(100px);
    opacity: 0.4;
    pointer-events: none;

    &--orange {
      width: 440px;
      height: 440px;
      background: rgba(255, 164, 9, 0.28);
      top: -180px;
      left: -140px;
    }

    &--blue {
      width: 420px;
      height: 420px;
      background: rgba(91, 148, 188, 0.26);
      bottom: -170px;
      right: -130px;
    }
  }

  &__dots {
    position: absolute;
    bottom: 10%;
    left: 5%;
    width: 110px;
    height: 110px;
    background-image: radial-gradient(rgba(91, 148, 188, 0.4) 2px, transparent 2px);
    background-size: 22px 22px;
    opacity: 0.5;
    pointer-events: none;
  }

  &__container {
    position: relative;
    z-index: 2;
    max-width: 1120px;
    width: 100%;
    margin: 0 auto;
  }

  &__head {
    text-align: center;
    margin-bottom: 56px;
  }

  &__eyebrow {
    display: inline-block;
    background: rgba(255, 164, 9, 0.14);
    color: #b06d00;
    font-size: 13px;
    font-weight: 700;
    letter-spacing: 1.4px;
    text-transform: uppercase;
    padding: 7px 16px;
    border-radius: 999px;
    margin: 0 0 18px;
  }

  &__title {
    margin: 0 0 18px;
    font-size: clamp(30px, 3.6vw, 40px);
    font-weight: 800;
    line-height: 1.25;
    color: #2b2b2b;

    &-accent {
      color: #ffa409;
    }
  }

  &__bar {
    display: inline-block;
    width: 96px;
    height: 5px;
    border-radius: 999px;
    background: linear-gradient(90deg, #ffa409 0%, #5B94BC 100%);
  }

  &__marquee {
    position: relative;
    overflow: hidden;
    padding: 8px 0;

    -webkit-mask-image: linear-gradient(to right, transparent, #000 9%, #000 91%, transparent);
    mask-image: linear-gradient(to right, transparent, #000 9%, #000 91%, transparent);
  }

  &__track {
    display: flex;
    align-items: center;
    gap: 20px;
    width: max-content;
    animation: par-scroll 38s linear infinite;

    &:hover {
      animation-play-state: paused;
    }
  }

  &__group {
    display: flex;
    align-items: center;
    gap: 20px;
  }

  &__slide {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 88px;
    padding: 0 26px;
    background: #fff;
    border: 1px solid rgba(43, 43, 43, 0.07);
    border-radius: 18px;
    box-shadow: 0 10px 26px rgba(43, 43, 43, 0.06);
    transition: transform 0.35s ease, box-shadow 0.35s ease, border-color 0.35s ease;

    img {
      max-height: 46px;
      max-width: 170px;
      object-fit: contain;
      filter: grayscale(1);
      opacity: 0.78;
      transition: filter 0.3s ease, opacity 0.3s ease;
    }

    &:hover {
      transform: translateY(-4px);
      border-color: rgba(255, 164, 9, 0.35);
      box-shadow: 0 16px 34px rgba(240, 136, 0, 0.18);

      img {
        filter: grayscale(0);
        opacity: 1;
      }
    }
  }
}

@keyframes par-scroll {
  from {
    transform: translateX(0);
  }

  to {
    transform: translateX(-33.333%);
  }
}

@media (max-width: 991px) {
  .par {
    padding: 72px 24px;

    &__title {
      font-size: 28px;
    }

    &__slide {
      height: 76px;
      padding: 0 20px;

      img {
        max-height: 40px;
        max-width: 140px;
      }
    }
  }
}

@media (max-width: 600px) {
  .par {
    padding: 56px 20px;

    &__title {
      font-size: 22px;
    }

    &__head {
      margin-bottom: 40px;
    }

    &__track {
      gap: 14px;
    }

    &__group {
      gap: 14px;
    }

    &__slide {
      height: 64px;
      padding: 0 16px;
      border-radius: 14px;

      img {
        max-height: 34px;
        max-width: 110px;
      }
    }
  }
}

</style>
